
<template>
    <div>
        <a-modal
            :width="900"
            :visible="viewActivityInfo"
            :destroyOnClose="true"
            title='活动信息'
            @cancel="close"
            :footer="null"
            >
            <a-card
                class="card-box"
                :bordered="false"
                :tabList="tabListNoTitle"
                :activeTabKey="noTitleKey"
                @tabChange="tabChange"
                >
                <div v-show="noTitleKey == 1">
                    <a-row v-show="tenActiveUserInfo.name && tenActiveUserInfo.buyTimes != 0">
                        <a-col class="mb24">
                            <span class="font">中文姓名：{{tenActiveUserInfo.name}}</span>
                        </a-col>
                        <a-col class="mb24">
                            <span class="font">英文姓名：{{tenActiveUserInfo.englishName}}</span>
                            <a-button v-if="getBtnByAuth('changeTencentInfo')" class="ml24" type="primary" @click="openChangeUserTenActivityInfo">更改腾讯员工信息</a-button>
                        </a-col>
                        <a-col class="mb24">
                            <span class="font">腾讯员工照片：</span>
                            <img style="display: block;" class="mt24" width="700" :src="tenActiveUserInfo.imageUrl" alt="">
                        </a-col>
                    </a-row>
                    <a-empty class="pt24 pb24" v-show="!(tenActiveUserInfo.name && tenActiveUserInfo.buyTimes != 0)"/>
                </div>
                <div v-show="noTitleKey == 2">
                    <div v-show="Boolean(teacherActiveUserInfo.teachersNo)">
                        <div class="flex flex-start">
                            <div>
                                <a-form layout="inline" :form="teacherActiveForm">
                                    <a-form-item :required="false" label="教师证编号">
                                        <a-input :disabled="disabledTeacherField" placeholder="请输入" v-decorator="['teachersNo', {rules: [{required: true, message: ' '}]}]"></a-input>
                                    </a-form-item>
                                </a-form>
                            </div>
                            <div v-if="getBtnByAuth('changeTencentInfo')">
                                <a class="text-primary" v-if="disabledTeacherField" @click="disabledTeacherField = false">修改</a>
                                <template v-else>
                                    <a class="text-primary" @click="confirmChangeUserTeacherActivityInfo">保存</a>
                                    <a-divider type="vertical"></a-divider>
                                    <a class="text-primary" @click="cancelChangeUserTeacherActivityInfo">取消</a>
                                </template>
                            </div>
                        </div>
                        <div class="mt24">
                            <div class="font">教师证照片：</div>
                            <img style="display: block;" class="mt24" width="700" :src="teacherActiveUserInfo.imageUrl" alt="">
                        </div>
                    </div>
                    <a-empty class="pt24 pb24" v-show="!Boolean(teacherActiveUserInfo.teachersNo)"/>
                </div>
            </a-card>
        </a-modal>
        <a-modal
            width="500px"
            :visible="visibleChangeUserTenActivityInfo"
            :destroyOnClose="true"
            title='更改腾讯员工信息'
            @cancel="visibleChangeUserTenActivityInfo = false;"
            @ok="confirmChangeUserTenActivityInfo"
            >
            <a-form :form="tenActiveForm">
                <a-form-item :labelCol="{span: 5}" :wrapperCol="{span: 17}" label="原英文名">
                    <span>{{tenActiveUserInfo.englishName}}</span>
                </a-form-item>
                <a-form-item :labelCol="{span: 5}" :wrapperCol="{span: 17}" label="新英文名">
                    <a-input :maxLength="50" @change="changeUserTenActivityInfo" placeholder="请输入" v-decorator="['englishName', {rules: [{required: true, message: ' '},{pattern: /^(?!\d+$)[\da-zA-Z]+$/, message: '英文姓名不能为纯数字，请检查后重新输入'},]}]"></a-input>
                    <span class="text-fail"> * 请注意大小写</span>
                </a-form-item>
            </a-form>
        </a-modal>
    </div>
</template>

<script>
export default {
    data() {
        const tabListNoTitle = [
            {
                key: '1',
                tab: '腾讯活动'
            },
            {
                key: '2',
                tab: '教师节活动'
            },
        ]
        return {
            viewActivityInfo: false,
            visibleChangeUserTenActivityInfo: false,
            noTitleKey: "1",
            tabListNoTitle,
            userInfo: {},
            tenActiveUserInfo: {},
            teacherActiveUserInfo: {},
            disabledTeacherField: true
        }
    },
    beforeCreate() {
        this.tenActiveForm = this.$form.createForm(this);
        this.teacherActiveForm = this.$form.createForm(this);
    },
    mounted() {

    },
    methods: {
        open(item) {
            this.viewActivityInfo = true;
            this.userInfo = item;
            this.getUserTenActivityInfo();
            this.getUserTeacherActivityInfo();
        },
        close() {
            this.viewActivityInfo = false;
            setTimeout(() => {
                this.noTitleKey = '1';
                this.userInfo = {};
                this.tenActiveUserInfo = {};
                this.teacherActiveUserInfo = {};
                this.disabledTeacherField = true;
            }, 500);
        },
        tabChange(key) {
            this.noTitleKey = key;
        },
        changeUserTenActivityInfo(e) {
            let name = e.target.value;
            this.$nextTick(() => {
                this.tenActiveForm.setFieldsValue({
                    englishName: name.replace(/[^0-9a-zA-Z]/g, ""),
                })
                this.tenActiveForm.validateFields(['englishName'], { force: true });
            })
        },
        confirmChangeUserTenActivityInfo() {
            this.tenActiveForm.validateFields((err, values) => {
                if (err) return;
                let { imageUrl, name } = this.tenActiveUserInfo;
                this.$api.user.saveTencent({
                    body: {
                        name,
                        imageUrl,
                        userId: this.userInfo.id,
                        englishName: values.englishName
                    }
                }).then(res => {
                    this.tenActiveUserInfo.englishName = values.englishName.trim();
                    this.$message.success("保存成功");
                    this.visibleChangeUserTenActivityInfo = false;
                })
            });
        },
        openChangeUserTenActivityInfo() {
            this.visibleChangeUserTenActivityInfo = true;
        },
        getUserTenActivityInfo() {
            this.$api.user.getTencent({
                params: {
                    userId: this.userInfo.id,
                }
            }).then(res => {
                if (Boolean(res)) {
                    this.tenActiveUserInfo = res;
                }
            })
        },
        getUserTeacherActivityInfo() {
            this.teacherActiveForm.setFieldsValue({teachersNo: undefined});
            this.teacherActiveUserInfo = {};
            this.$api.user.getTeacher2021({
                params: {
                    userId: this.userInfo.id,
                }
            }).then(res => {
                if (Boolean(res)) {
                    this.teacherActiveForm.setFieldsValue({teachersNo: res.teachersNo});
                    this.teacherActiveUserInfo = res;
                }
            })
        },
        cancelChangeUserTeacherActivityInfo() {
            this.teacherActiveForm.setFieldsValue({teachersNo: this.teacherActiveUserInfo.teachersNo});
            this.disabledTeacherField = true;
        },
        confirmChangeUserTeacherActivityInfo() {
            this.teacherActiveForm.validateFields((err, values) => {
                if (err) return;
                this.$api.user.saveTeacher2021({
                    body: {
                        userId: this.userInfo.id,
                        teachersNo: values.teachersNo
                    }
                }).then(res => {
                    this.disabledTeacherField = true;
                    this.$message.success("保存成功");
                })
            });
        }
    }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

</style>
